export default "__VITE_ASSET__Bp3lgHIC__"